const ModelCardSkeleton = () => (
  <div className="bg-card border border-border rounded-2xl overflow-hidden">
    {/* Image area */}
    <div className="w-full h-48 bg-secondary" />

    <div className="p-6">
      {/* Brand tag + fuel badge row */}
      <div className="flex justify-between mb-5">
        <div className="h-6 w-20 bg-secondary rounded-full" />
        <div className="h-6 w-16 bg-secondary rounded-full" />
      </div>

      {/* Model name */}
      <div className="mb-4 pb-4 border-b border-border">
        <div className="h-6 bg-secondary rounded-lg w-2/3" />
      </div>

      {/* Specs */}
      <div className="space-y-3 mb-4">
        <div className="flex justify-between gap-3">
          <div className="h-4 bg-secondary rounded w-20" />
          <div className="h-4 bg-secondary rounded w-16" />
        </div>
        <div className="flex justify-between gap-3">
          <div className="h-4 bg-secondary rounded w-16" />
          <div className="h-4 bg-secondary rounded w-12" />
        </div>
        <div className="pt-2 border-t border-border">
          <div className="h-3 bg-secondary rounded w-20 mb-2" />
          <div className="h-7 bg-secondary rounded-lg w-full" />
        </div>
      </div>

      {/* Price */}
      <div className="pt-4 mt-4 border-t border-border flex justify-between">
        <div className="h-4 bg-secondary rounded w-12" />
        <div className="h-6 bg-secondary rounded w-20" />
      </div>

      {/* Buttons */}
      <div className="mt-4 pt-3 border-t border-border flex gap-2">
        <div className="flex-1 h-10 bg-secondary rounded-xl" />
        <div className="flex-1 h-10 bg-secondary rounded-xl" />
      </div>
    </div>
  </div>
);

interface BrandDetailSkeletonProps {
  modelCount?: number;
}

export const BrandDetailSkeleton = ({ modelCount = 9 }: BrandDetailSkeletonProps) => {
  const count = Math.min(Math.max(modelCount, 3), 12);

  return (
    <div className="w-full animate-pulse">
      {/* Brand header */}
      <div className="mb-8 text-center">
        {/* Logo */}
        <div className="flex items-center justify-center mb-3">
          <div className="w-20 h-20 sm:w-24 sm:h-24 bg-secondary rounded-2xl" />
        </div>

        {/* Brand name */}
        <div className="h-9 bg-secondary rounded-xl w-48 mx-auto mb-3" />

        {/* Description lines */}
        <div className="space-y-2 mb-4 max-w-lg mx-auto">
          <div className="h-4 bg-secondary rounded w-full" />
          <div className="h-4 bg-secondary rounded w-4/5 mx-auto" />
        </div>

        {/* Badges */}
        <div className="flex items-center justify-center gap-3">
          <div className="h-7 w-32 bg-secondary rounded-full" />
          <div className="h-7 w-36 bg-secondary rounded-full" />
        </div>
      </div>

      {/* Filter tabs */}
      <div className="flex gap-2 justify-center mb-8 flex-wrap">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="h-9 w-24 bg-secondary rounded-xl" />
        ))}
      </div>

      {/* Section title */}
      <div className="h-6 bg-secondary rounded w-32 mb-6" />

      {/* Model cards grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {Array.from({ length: count }).map((_, i) => (
          <ModelCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );
};
